// extracted by mini-css-extract-plugin
export default {"addButton":"UserCreateForm_addButton__+uJg9"};